import React from 'react'

import { remove } from '../ServiceTypeActions'
import GlobalList from '../../components/GlobalList'
import { exportFormatedMoney } from '../../../util/utils'

function createData(
  id,
  name,
  value,
  time,
  category,
  status,
  tipo,
  active_to_laundry,
  default_to_laundry
) {
  return {
    id,
    name,
    value,
    time,
    category,
    status,
    tipo,
    active_to_laundry,
    default_to_laundry,
    update: 'update-service-types',
    delete: 'delete-service-types',
    link_update: `/service-type/${id}/edit`,
  }
}

const headCells = [
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    label: 'ID',
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Nome',
  },
  {
    id: 'value',
    numeric: true,
    disablePadding: false,
    label: 'Valor Padrão',
  },
  {
    id: 'time',
    numeric: true,
    disablePadding: false,
    label: 'Tempo padrão',
  },
  {
    id: 'category',
    numeric: true,
    disablePadding: false,
    label: 'Categoria',
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
  },
  {
    id: 'tipo',
    numeric: false,
    disablePadding: false,
    label: 'Tipo',
  },
  {
    id: 'active_to_laundry',
    numeric: false,
    disablePadding: false,
    label: 'Ativo Parceiros',
  },
  {
    id: 'default_to_laundry',
    numeric: false,
    disablePadding: false,
    label: 'Padrão Parceiros',
  },
  {
    id: 'actions',
    numeric: true,
    disablePadding: false,
    label: 'Ações',
  },
]

function List(props) {
  const { items } = props
  const rows = []

  items.map(item => {
    return rows.push(
      createData(
        item.id,
        item.name,
        exportFormatedMoney(item.default_value),
        item.execution_time,
        item.serviceCategory?.name,
        item.status_text,
        item.attendanceType_text,
        item.active_to_laundry ? 'Ativo' : 'Inátivo',
        item.default_to_laundry ? 'Sim' : 'Não'
      )
    )
  })

  return (
    <GlobalList
      {...props}
      headCells={headCells}
      rows={rows}
      remove={remove}
      orderField="id"
    />
  )
}

export default List
